export default __webpack_public_path__ + "static/media/hotel.ef713147.png";